import { Box, Button, Dialog, Portal } from '@chakra-ui/react'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useBoolean } from 'react-use'
import { TextArea } from 'uikit'
import { useApproveIdentification } from './services/useApproveIdentification'

export const ApproveIdentificationModal = ({ userId }) => {
  const queryClient = useQueryClient()
  const [isOpen, setIsOpen] = useBoolean(false)
  const { mutate: approve, isPending: isLoading } = useApproveIdentification(userId)
  const [commentValue, setCommentValue] = useState('')

  const handleSubmit = () => {
    const payload = {
      identificationSupportComment: commentValue,
    }
    approve(payload, {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['userCard'] })
        setIsOpen(false)
      },
    })
  }

  return (
    <>
      <Button width="100%" onClick={() => setIsOpen(true)} colorPalette="green">
        Подтвердить
      </Button>
      <Dialog.Root open={isOpen} onOpenChange={(e) => setIsOpen(e.open)}>
        <Portal>
          <Dialog.Backdrop />
          <Dialog.Positioner>
            <Dialog.Content>
              <Dialog.Header>
                <Dialog.Title>Подтверждение идентификации</Dialog.Title>
                <Dialog.CloseTrigger mt={1} />
              </Dialog.Header>
              <Dialog.Body>
                <TextArea
                  value={commentValue}
                  onChange={(e) => setCommentValue(e.target.value)}
                  placeholder="Введите комментарий"
                />
                <Box pt="30px">
                  <Button
                    colorPalette="orange"
                    loading={isLoading}
                    onClick={handleSubmit}
                    disabled={commentValue === ''}
                  >
                    Подтвердить
                  </Button>
                </Box>
              </Dialog.Body>
            </Dialog.Content>
          </Dialog.Positioner>
        </Portal>
      </Dialog.Root>
    </>
  )
}
